import { render, staticRenderFns } from "./CoreBreadcrumbs.vue?vue&type=template&id=406fe1e3&scoped=true&"
import script from "./CoreBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./CoreBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./CoreBreadcrumbs.vue?vue&type=style&index=0&id=406fe1e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fe1e3",
  null
  
)

export default component.exports